export const contactsData = {
    email: 'lwijesuriya97@gmail.com',
    phone: '+61449290520',
    address: 'Brisbane, Australia',
    github: 'https://github.com/LahiruWijesuriya',
    facebook: '',
    linkedIn: 'https://www.linkedin.com/in/lahiru-w/',
    twitter: '',
    medium: '',
    stackOverflow: '',
    devUsername: "lahiru"
}